import React from 'react';
import PropTypes from 'prop-types';
import './page_header.scss';

const PageHeader = (props) => {
  const titleContent = (
    <React.Fragment>
      <div>
        {props.title}
        {props.subtitle && (
          <span className="text-muted">{props.subtitle}</span>
        )}
        {props.belowTitleAction && <div>{props.belowTitleAction}</div>}
      </div>
    </React.Fragment>
  );

  return (
    <div className={`row-eq-height ${props.useNewDesign ? 'new-header-design' : 'mb-3 mt-3'} flex-wrap align-items-start`}>
      <h2 className="grow my-0 page-header-title">{titleContent}</h2>
      {props.actions}
    </div>
  );
};

PageHeader.propTypes = {
  actions: PropTypes.node,
  belowTitleAction: PropTypes.node,
  subtitle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  useNewDesign: PropTypes.bool,
};

const Actions = (props) => {
  return <React.Fragment>{props.children}</React.Fragment>;
};

Actions.propTypes = {
  children: PropTypes.node
};

PageHeader.Actions = Actions;

export default PageHeader;
